const closeButtonLabel = "Cerrar";
const esCO = {
  closeButtonLabel
};
export {
  closeButtonLabel,
  esCO as default
};
